<template>
    <BreadCrumb PageTitle="Liste des Reglements" />
    <ListeReglement />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeReglement from "../../components/Reglement/ListeReglement.vue";

    export default defineComponent({
        name: "ListeClientPage",
        components: {
            BreadCrumb,
            ListeReglement,
        },
    });
</script>